import { useSnapshot } from "valtio";
import { mapStore } from "src/js/stores/map/store";
import { useMapLayer } from "react-migration/lib/map/useMapLayer";
import { LayerTypeMapLayerProps } from "../../../types";
import { PermitsClusteredViewportSearchMapLayer } from "./PermitsClusteredViewportSearchMapLayer";
import { usePermitsContext } from "../Context";
import {
  PermitFilters,
  PermitRootType,
  PermitStatusFilter,
  PermitSubType,
} from "@landtechnologies/search-layer-contracts";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { PermitFormState } from "../state/usePermitFilterState";

function groupByRoot(ids: string[]): PermitFilters["enabledTypes"] {
  const result = {} as Record<PermitRootType, PermitSubType[]>;

  for (const id of ids) {
    const [root, sub] = id.split(".") as [PermitRootType, PermitSubType];
    if (!sub) {
      result[root] ??= [];
    } else {
      result[root] ??= [];
      result[root].push(sub);
    }
  }

  return Object.entries(result).map(([type, subTypes]) => ({
    type: type as PermitRootType,
    subTypes,
  }));
}

const getFilters = (filters: PermitFormState): PermitFilters | PermitStatusFilter => {
  if (!hasFeature(Feature.permitAllFilters) && hasFeature(Feature.permitStatusFilters)) {
    return {
      enabledStatuses: filters.enabledStatuses,
    } satisfies PermitStatusFilter;
  } else
    return {
      ...filters,
      enabledTypes: groupByRoot(filters.enabledTypes),
    };
};

export function PermitsLayerMapLayer({ visible, zOrder, layer }: LayerTypeMapLayerProps) {
  const { googleMap } = useSnapshot(mapStore);
  const { mapType } = useSnapshot(mapStore.settings);
  const { state: filters } = usePermitsContext();

  useMapLayer(
    () => ({
      layer: new PermitsClusteredViewportSearchMapLayer({
        id: "permits-clustered-viewport-search-map-layer",
        visible,
        googleMap,
        mapType,
        filters: getFilters(filters),
        clusterEventProperties: {
          selectionLayerId: layer.id,
        },
      }),
      zOrder,
    }),
    [visible, googleMap, mapType, filters, layer.id, zOrder]
  );

  return null;
}
